<template>
  <div id="base-route-dropdown">
    <button type="button"
            class="dropdown-button"
            :class="{expanded: isExpanded}"
            @click="toggleDropDown"
    >
      <span>{{ getFilterName }}</span><ArrowIcon />
    </button>
    <div class="dropdown-content" :class="{expanded: isExpanded, collapsed: !isExpanded}">
      <router-link v-for="route in routes"
                   :key="route.id"
                   :to="{name: route.name, params: {id: getLocationName()}}"
                   @click.native="toggleDropDown"
      >
        {{ route.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
import ArrowIcon from '@/components/svg/ArrowIcon';
export default {
  name: "BaseRouteDropdown",
  components: {
    ArrowIcon
  },
  props: {
    routes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedRoute: 'Residents',
      isExpanded: false
    }
  },
  computed: {
    getFilterName() {
      return this.$route.name.split('-').pop();
    }
  },
  methods: {
    toggleDropDown(){
      this.isExpanded = !this.isExpanded;
    },
    getLocationName() {
      if(this.$route.params.id) {
        return this.$route.params.id
      } else {
        return 'Athens';
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";
div#base-route-dropdown {
  background-color: transparent;
  position: relative;
  margin:0 10px;
}
.dropdown-button {
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  @include font-12-md;
  text-transform: uppercase;
  height: 36px;
  border: 1px solid $c_border_grey !important;
  color: $c_black;
  appearance: none;
  z-index: 1;
  span {
    margin-right: 30px;
  }
  svg {
    transform: rotate(0deg);
    fill: $c_black;
  }
  &.expanded {
    svg {
      transform: rotate(180deg);
    }
  }
}
.dropdown-content{
  padding: 10px 20px;
  position: absolute;
  background-color: $c_white;
  width: 100%;
  top: 100%;
  z-index: -1;
  margin-top: 5px;
  border-radius: 8px;
  transition: transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), opacity 0.3s ease-in;
  transform: translateY(-40px);
  transform-origin: top;
  opacity: 0;
  &.expanded {
    transform: translateY(0);
    opacity: 1;
    filter: drop-shadow(2px 4px 6px rgba(128, 128, 128, 0.481));
  }
  &.collapsed {
    transform-origin: top;
    transform: translateY(-40px);
    opacity: 0;
    visibility: hidden;
    transition: transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), opacity 0.3s ease-out;
  }
  @include media-breakpoint-down(md) {
    position: fixed;
    top: 235px;
    left: 20px;
    width: calc(100vw - 40px);
    z-index: 1;
  }
  a {
    @include font-12-md;
    display: block;
    color: $c_medium_grey_text;
    text-transform: uppercase;
    padding: 5px 0;
    @include media-breakpoint-down(md) {
      padding: 10px 0;
    }
    &.router-link-active {
      color: $c_black;
      pointer-events: none;
    }
    &:hover {
      color: $c_base;
    }
  }
}

</style>